// extracted by mini-css-extract-plugin
module.exports = {"logo":"BrandBanner_logo__3DUjs"};